// components/DatePickerInput.js
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerInput = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  invalid = false,
  minDate = null,
}) => {
  return (
    <div className="flex items-center gap-4 w-full mb-4">
      <label
        htmlFor={id}
        className="text-base font-medium text-black  whitespace-nowrap"
      >
        {label}
        {required && " *"}
      </label>
      <div className="flex-1">
        <DatePicker
          id={id}
          selected={value || null}
          onChange={onChange}
          dateFormat="MM/dd/yyyy"
          className={`w-full px-0 py-2 border-0 border-b-2 ${
            invalid ? "border-b-red-500" : "border-b-gray-300"
          } ${disabled ? "!text-black !opacity-100" : ""} focus:outline-none focus:ring-0 focus:border-b-indigo-500 bg-slate-50 font-medium text-black`}
          minDate={minDate}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          wrapperClassName="w-full"
          disabled={disabled}
          scrollableMonthYearDropdown
        />
      </div>
    </div>
  );
};

export default DatePickerInput;
